import { useContext } from 'react';
import { FeatureFlags } from 'components/providers/FeatureFlags';
import type { FeatureFlagName } from 'types/FeatureFlag';

export const useFeatureFlagsContext = (): {
  isEnabled: (name: FeatureFlagName) => boolean;
} => {
  const context = useContext(FeatureFlags);

  if (!context) {
    throw new Error('useFeatureFlagsContext must be used within a FeatureFlagsProvider');
  }

  const isEnabled = (name: FeatureFlagName): boolean => context.get(name) ?? false;

  return { isEnabled };
};
